var _style, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSkaiInteeligenceLogoWhite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "40 100 532 200",
    style: {
      enableBackground: "new 40 100 532 200"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n\t.st1{fill:#0071FE;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M126.63,154.98c-20.15-4.08-28.96-5.64-28.96-10.63c0-4.5,8.02-7.32,18.24-7.32c13.79,0,18.8,6.45,19.34,10.94 h37.78l-0.13-2.62c-1.31-17.21-22.42-29.18-56.48-29.18c-28.93,0-56.95,9.31-56.95,29.27c0,17.49,21.47,24.2,50.89,30.27 c19.5,4.02,27.98,5.98,27.98,11.54c0,6.41-10.12,8.42-19.62,8.42c-16.24,0-23.81-6.17-24.88-12.39H55.13l0.07,2.26 c0.78,18.86,24.68,31.81,63.71,31.81c36.14,0,58.66-11.86,58.66-29.81C177.57,166.76,151.45,160.01,126.63,154.98z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 520.01,
    y: 120.3,
    className: "st0",
    width: 36.86,
    height: 92.91
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "437.48,186.32 448.47,213.21 488.73,213.21 466.93,168.62  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "432.17,173.32 437.48,186.32 392.72,213.21 352.46,213.21 397.89,120.3 443.31,120.3 465.21,165.09  432.17,173.32 420.6,144.98 406.39,179.76  "
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st1",
    points: "465.2,165.09 432.17,173.32 437.48,186.32 466.93,168.62  "
  }), /*#__PURE__*/React.createElement("rect", {
    x: 214.12,
    y: 120.3,
    className: "st0",
    width: 36.86,
    height: 92.91
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "250.98,163.68 291.13,213.21 338.21,213.21 292.17,163.25 330.14,120.3 284.1,120.3  "
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M74.61,244.16v22.32h-5.13v-22.32H74.61z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M107.64,244.16l5.88,9.69c0.34,0.58,0.69,1.21,1.04,1.88c0.35,0.67,0.67,1.3,0.98,1.91l1.05,2.1h0.06 c-0.06-0.76-0.11-1.53-0.15-2.31c-0.04-0.66-0.07-1.37-0.09-2.13c-0.02-0.76-0.03-1.46-0.03-2.1v-9.03h4.89v22.32h-5.25l-5.82-9.57 c-0.34-0.56-0.69-1.19-1.05-1.89c-0.36-0.7-0.69-1.35-0.99-1.95c-0.36-0.7-0.71-1.41-1.05-2.13h-0.06l0.12,2.34 c0.04,0.66,0.07,1.37,0.11,2.13c0.03,0.76,0.04,1.46,0.04,2.1v8.97h-4.89v-22.32H107.64z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M166.36,244.16v4.35h-6.66v17.97h-5.13v-17.97h-6.63v-4.35H166.36z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M209.81,244.16v4.26h-11.64v4.44h10.08v4.05h-10.08v5.19h11.85v4.38h-16.95v-22.32H209.81z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M242.28,244.16v17.94h10.29v4.38h-15.39v-22.32H242.28z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M284.41,244.16v17.94h10.29v4.38h-15.39v-22.32H284.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M326.56,244.16v22.32h-5.13v-22.32H326.56z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M370.49,263.49c-0.66,1.24-1.55,2.14-2.67,2.69c-1.12,0.55-2.37,0.82-3.75,0.82c-1.6,0-3.04-0.27-4.31-0.82 c-1.27-0.55-2.37-1.32-3.29-2.3c-0.98-1.06-1.72-2.31-2.22-3.74c-0.5-1.43-0.75-3.01-0.75-4.73c0-1.92,0.33-3.68,0.99-5.27 c0.66-1.59,1.62-2.92,2.88-3.98c0.9-0.76,1.93-1.35,3.09-1.77c1.16-0.42,2.48-0.63,3.96-0.63c1.4,0,2.66,0.18,3.78,0.54 c1.12,0.36,2.09,0.86,2.91,1.5c0.82,0.64,1.48,1.41,1.99,2.3c0.51,0.89,0.87,1.87,1.07,2.93h-5.1c-0.28-0.84-0.78-1.56-1.5-2.15 c-0.72-0.59-1.72-0.89-3-0.89c-1,0-1.87,0.19-2.6,0.57c-0.73,0.38-1.34,0.9-1.83,1.56c-0.49,0.66-0.86,1.45-1.09,2.35 c-0.24,0.91-0.36,1.89-0.36,2.93c0,1.08,0.14,2.07,0.42,2.97c0.28,0.9,0.67,1.68,1.18,2.34c0.51,0.66,1.13,1.18,1.86,1.55 c0.73,0.37,1.55,0.56,2.48,0.56c0.78,0,1.49-0.13,2.12-0.38c0.63-0.25,1.16-0.58,1.59-0.98c0.43-0.4,0.76-0.87,1.01-1.4 c0.24-0.53,0.36-1.07,0.36-1.64v-0.09h-4.5v-3.81h9.33v11.94H371l-0.42-3H370.49z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M418.65,244.16v4.26h-11.64v4.44h10.08v4.05h-10.08v5.19h11.85v4.38h-16.95v-22.32H418.65z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M451.24,244.16l5.88,9.69c0.34,0.58,0.69,1.21,1.04,1.88c0.35,0.67,0.67,1.3,0.98,1.91l1.05,2.1h0.06 c-0.06-0.76-0.11-1.53-0.15-2.31c-0.04-0.66-0.07-1.37-0.09-2.13c-0.02-0.76-0.03-1.46-0.03-2.1v-9.03h4.89v22.32h-5.25l-5.82-9.57 c-0.34-0.56-0.69-1.19-1.05-1.89c-0.36-0.7-0.69-1.35-0.99-1.95c-0.36-0.7-0.71-1.41-1.05-2.13h-0.06l0.12,2.34 c0.04,0.66,0.08,1.37,0.11,2.13c0.03,0.76,0.04,1.46,0.04,2.1v8.97h-4.89v-22.32H451.24z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M498.18,266.13c-1.35-0.58-2.51-1.39-3.47-2.42c-0.96-1.03-1.71-2.26-2.24-3.68c-0.53-1.42-0.8-2.96-0.8-4.62 c0-1.66,0.26-3.2,0.78-4.62c0.52-1.42,1.26-2.65,2.21-3.69s2.1-1.86,3.45-2.45c1.35-0.59,2.86-0.88,4.52-0.88 c1.24,0,2.38,0.15,3.42,0.44c1.04,0.29,1.94,0.72,2.7,1.3c1.02,0.74,1.82,1.64,2.39,2.7c0.57,1.06,0.93,2.22,1.07,3.48h-5.1 c-0.16-1.06-0.64-1.93-1.43-2.63c-0.79-0.69-1.82-1.04-3.08-1.04c-0.96,0-1.8,0.19-2.51,0.56c-0.71,0.37-1.3,0.88-1.77,1.55 c-0.47,0.66-0.82,1.44-1.06,2.34c-0.24,0.9-0.36,1.88-0.36,2.94c0,1.06,0.14,2.04,0.41,2.94c0.27,0.9,0.65,1.68,1.14,2.33 c0.49,0.65,1.09,1.16,1.8,1.53c0.71,0.37,1.51,0.56,2.39,0.56c1.38,0,2.47-0.39,3.27-1.17c0.8-0.78,1.26-1.75,1.38-2.91h5.13 c-0.08,1.12-0.36,2.18-0.84,3.17c-0.48,0.99-1.1,1.87-1.86,2.63c-0.84,0.84-1.84,1.47-3,1.89c-1.16,0.42-2.52,0.63-4.08,0.63 C501.02,267,499.53,266.71,498.18,266.13z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M555.84,244.16v4.26H544.2v4.44h10.08v4.05H544.2v5.19h11.85v4.38H539.1v-22.32H555.84z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSkaiInteeligenceLogoWhite);
export default __webpack_public_path__ + "static/media/SKAI_INTEELIGENCE_logo_white.94e440bbcbe3e402049a3b1a39605910.svg";
export { ForwardRef as ReactComponent };